import IonAlert from '../../../../../components/Modal/ModalAlert';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonFab, IonFabButton, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonItem, IonLabel, IonLoading, IonModal, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSearchbar, IonTitle, isPlatform, useIonViewWillEnter } from '@ionic/react';
import { Buffer } from 'buffer';
import { trashOutline, add, arrowBack } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { excluiUsuario, listaEquipe, listaEquipePorPerfil, requestService, resetSenhaUsuario } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import UsuariosTotemCad from '../UsuariosTotemCad/UsuariosTotemCad';
import CadastroGrid from '../../../../../components/Grid/CadastroGrid';
import '../CadastrosLayout.css';

type Props = {
  abrirMenu: boolean;
};

const UsuariosTotem: React.FC<Props> = (props: Props) => {

  const history = useHistory();
  const { loja, setLoja } = useContext(MessageContext);
  const [showDetalhes, setShowDetalhes] = useState(false);
  const [arrayOperacoes, setArrayOperacoes] = useState<any>([]);
  const [carregandoCadastros, setCarregandoCadastros] = useState(true);
  const [erroCadastros, setErroCadastros] = useState(false);
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [operacaopk, setOperacaopk] = useState("");
  const [textToast, setTextToast] = useState("");
  const [mensagem, setMensagem] = useState("");
  const [cpf, setCpf] = useState("");
  const [showResetSenha, setShowResetSenha] = useState(false);
  const [showExcluirUsuario, setShowExcluirUsuario] = useState(false);
  const [showSucesso, setShowSucesso] = useState(false);
  const [showErro, setShowErro] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [pesquisa, setPesquisa] = useState<string>();
  const [usuario, setUsuario] = useState<any>();
  const [interno, setInterno] = useState<boolean>(true);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));

  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);

  const inputDetalhesRef = useRef<any>(null);

  useIonViewWillEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarUsuarios();
  });

  const loadItens = () => (
    <CadastroGrid loading={carregandoCadastros} error={erroCadastros} onRetry={() => carregarUsuarios()} items={arrayOperacoes} matches={(value) => !pesquisa || pesquisa === "" || value.nomeMinusculo?.indexOf(pesquisa.toString()) > -1}
          variant="device" virtualized={false}
          canEdit={(value) => acessos?.cadastros == 'edicao'}
          onEdit={(value) => { setUsuario(value); setShowDetalhes(true); }}
          renderActions={(value) => <><IonButton size="small" fill='clear' shape="round"  slot="end" className="cadastros-delete" aria-label={`Excluir ${value.nome}`} hidden={acessos?.cadastros != 'edicao'} onClick={() => { setCpf(value.pk); setMensagem("Deseja realmente excluir o Totem " + value.nome + "?"); setShowExcluirUsuario(true) }}><IonIcon icon={trashOutline} aria-hidden="true" /></IonButton></>}

        />
  );

  function carregarUsuarios() {
    const consultar = async () => {

      let token: string = "";
      const tkn = localStorage.getItem("token");
      if (typeof (tkn) === "string") {
        token = tkn;
      }

      const resp = await fetch(
        listaEquipePorPerfil.url.replace("{perfil}", "totem").concat("?lojas=" + Buffer.from(loja).toString('base64')),
        {
          method: listaEquipePorPerfil.method,
          headers: [["token", token]],
          credentials: 'include'
        }
      );

      if (!resp.ok && resp.status !== 400 && resp.status !== 401) {
        throw new Error('Não foi possível carregar os cadastros');
      }
      const equipe = await resp.json();

      if (resp.status === 400 || resp.status === 401) {
        history.replace("/login/");
      } else {
        setArrayOperacoes(equipe.Items.sort((a: any, b: any) => (a.nome?.toLowerCase() > b.nome?.toLowerCase()) ? 1 : -1));
        if (equipe.LastEvaluatedKey) {
          setOperacaopk(equipe.LastEvaluatedKey.pk);
          setDesabilitarInfiniteScroll(false);
        } else {
          setOperacaopk("");
          setDesabilitarInfiniteScroll(true);
        }
      }
    };
    setCarregandoCadastros(true);
    setErroCadastros(false);
    return consultar()
      .catch(() => setErroCadastros(true))
      .finally(() => setCarregandoCadastros(false));
  }

  async function carregarMaisUsuarios($event: CustomEvent<void>) {
    await carregarMaisUsuariosChamada();
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisUsuariosChamada() {
    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    const res: Response = await fetch(listaEquipe.url + "?pk=" + operacaopk, {
      method: listaEquipe.method,
      headers: [["token", token]],
      credentials: 'include'
    });

    await res.json().then(async (operacoes) => {
      for (let i = 0; i < operacoes.Items.length; i++) {
        arrayOperacoes.push(operacoes.Items[i]);
      }
      if (operacoes.LastEvaluatedKey) {
        setOperacaopk(operacoes.LastEvaluatedKey.pk);
        setDesabilitarInfiniteScroll(false);
      } else {
        setOperacaopk("");
        setDesabilitarInfiniteScroll(true);
      }
    }).catch(err => console.error(err));

    if (res.status === 400 || res.status === 401) history.replace("/login/");
  }

  async function closeModal() {
    setShowDetalhes(false);
    carregarUsuarios();
  }

  async function closeModalSimple() {
    setShowDetalhes(false);
  }

  function doRefresh(event: any) {
    carregarUsuarios().finally(() => event.detail.complete());
  }

  return (
    <IonPage className="cadastros-page UsuariosTotem">
      <IonHeader className="ion-no-border">
        <IonToolbar className="cadastros-toolbar">
          <IonButtons slot="start">
            <IonBackButton icon={arrowBack} text=''></IonBackButton>
          </IonButtons>
          <IonTitle>Totem</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="cadastros-content">
        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        {(
          <IonFab className="cadastros-mobile-add" vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.cadastros != 'edicao'}>
            <IonFabButton color="tertiary" class="custom-fab-button" onClick={() => { setUsuario(null); setInterno(true); setShowDetalhes(true); }}>
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}

        <div className="cadastros-container">
          <div className="cadastros-heading"><div><h1>Totem</h1><p>Organize os pontos de autoatendimento da sua loja.</p></div><IonButton
                    fill="solid"
                    size="large"
                    className="cadastros-desktop-add"
                    hidden={acessos?.cadastros != 'edicao'}
                    onClick={() => {
                      setUsuario(null);
                      setShowDetalhes(true);
                    }}
                  >
                    <IonIcon slot="start" icon={add} />
                    Novo totem
                  </IonButton></div>
          <div className="cadastros-search" ><IonSearchbar
                  value={pesquisa}
                  onIonClear={() => setPesquisa(undefined)}
                  onIonChange={(e) => setPesquisa(e.detail.value?.toLowerCase())}
                  placeholder="Pesquisar"
                /></div>
          <section className="cadastros-grid-shell" aria-label="Registros cadastrados">
            {loadItens()}
          </section>
        </div>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisUsuarios(e)}
          position="bottom"
          disabled={carregandoCadastros || erroCadastros || desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>

        <IonLoading isOpen={showLoading} onDidDismiss={() => setShowLoading(false)} message="Registrando..." />
        <IonAlert
          isOpen={showResetSenha}
          onDidDismiss={() => setShowResetSenha(false)}
          header={'Reset de Senha'}
          message={mensagem}
          buttons={[
            { text: 'Cancelar', role: 'cancel' },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {
                requestService(resetSenhaUsuario.url.replace("{cpf}", cpf), {
                  method: resetSenhaUsuario.method,
                  headers: [["token", localStorage.getItem("token") || ""]],
                  credentials: 'include'
                },
                  history,
                  (response: any) => {
                    setTextToast(response.message);
                    setShowSucesso(true);
                  },
                  (error: any) => {
                    setTextToast(error.message);
                    setShowErro(true);
                  });
              }
            }
          ]}
        />

        <IonAlert
          isOpen={showExcluirUsuario}
          onDidDismiss={() => setShowExcluirUsuario(false)}
          header={'Exclusão de Totem'}
          message={mensagem}
          buttons={[
            { text: 'Cancelar', role: 'cancel' },
            {
              text: 'Confirmar',
              cssClass: 'primary',
              handler: () => {
                requestService(excluiUsuario.url.replace("{cpf}", cpf.replaceAll(/#/g, "%23")), {
                  method: excluiUsuario.method,
                  headers: [["token", localStorage.getItem("token") || ""]],
                  credentials: 'include'
                },
                  history,
                  (response: any) => {
                    carregarUsuarios();
                    setTextToast(response.message);
                    setShowSucesso(true);
                  },
                  (error: any) => {
                    setTextToast(error.message);
                    setShowErro(true);
                  });
              }
            }
          ]}
        />

        <IonAlert
          isOpen={showSucesso}
          onDidDismiss={() => setShowSucesso(false)}
          header={'Sucesso'}
          message={textToast}
          buttons={['OK']}
        />

        <IonAlert
          isOpen={showErro}
          onDidDismiss={() => setShowErro(false)}
          header={'Erro'}
          message={textToast}
          buttons={['OK']}
        />

        <IonModal className="fullscreen-modal cadastros-modal" onDidPresent={() => {
          if (inputDetalhesRef.current) {
            inputDetalhesRef.current.setFocus();
          }
        }} isOpen={showDetalhes} onDidDismiss={() => { setShowDetalhes(false); }}>
          <UsuariosTotemCad usuario={usuario} inputRef={inputDetalhesRef} closeAction={closeModal} closeActionSimple={closeModalSimple} setCliente={() => { }}></UsuariosTotemCad>
        </IonModal>
      </IonContent>
    </IonPage>
  );
};

export default UsuariosTotem;
